import { render, staticRenderFns } from "./FilterItemHeading.vue?vue&type=template&id=580e7bd6&"
import script from "./FilterItemHeading.vue?vue&type=script&lang=js&"
export * from "./FilterItemHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports